export const FILTER_OPTIONS = ['All Notes', 'Triads Only', 'Roots Only'];
